import { useCurrentClient } from "hooks/api/use-clients";

import { useEmailTypes as useEmailTypesQuery } from "hooks/api/use-email-types";

import { IEmailType } from "containers/admin/clients/client/components/email-types/email-types.types";

/** Stable identity while the query is in flight — a fresh `[]` re-fires every dependent effect and memo. */
const NO_EMAIL_TYPES: IEmailType[] = [];

const useEmailTypes = (): IEmailType[] => {
  const currentClient = useCurrentClient();
  const { data } = useEmailTypesQuery(currentClient.id);
  return (data ?? NO_EMAIL_TYPES) as unknown as IEmailType[];
};

export default useEmailTypes;
